import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { url } from '../../utils/constants';
import { useApiError } from '../../../hooks/useApiError';
import { useNotificationManager } from '../../../hooks/useNotificationManager';

export const useTransactions = (currentPage, filters, logout, navigate) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [idpdvs, setIdpdvs] = useState([]);
  const { error, handleError, retry } = useApiError();
  const { showError } = useNotificationManager();

  // Estados para os valores dos cards
  const [amountPaid, setAmountPaid] = useState(0);
  const [amountPending, setAmountPending] = useState(0);
  const [amountExpired, setAmountExpired] = useState(0);
  const [amountPaidF, setAmountPaidF] = useState(0);
  const [amountPendingF, setAmountPendingF] = useState(0);
  const [amountExpiredF, setAmountExpiredF] = useState(0);

  const convertToUTCString = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString();
  };

  const fetchTransactions = async () => {
    try {
      const token = await localStorage.getItem('token');
      const queryParams = new URLSearchParams({
        page: currentPage,
        ...memoizedFilters,
        dataInicio: convertToUTCString(memoizedFilters.dataInicio),
        dataFim: convertToUTCString(memoizedFilters.dataFim),
        status: memoizedFilters.status === 'Todos' ? '' : memoizedFilters.status
      });

      const response = await axios.get(url + `/api/v1/pagamento?${queryParams}`, {
        headers: {
          Authorization: 'Bearer ' + token
        }
      });

      const {
        data,
        totalcount,
        totalAmountPaid,
        totalAmountPending,
        totalAmountExpired,
        usersIdpdvs,
        totalAmountPaidF,
        totalAmountPendingF,
        totalAmountExpiredF
      } = response.data;

      setIdpdvs(usersIdpdvs || []);
      setTransactions(data);
      setAmountPaid(totalAmountPaid);
      setAmountPending(totalAmountPending);
      setAmountExpired(totalAmountExpired);
      setAmountPaidF(totalAmountPaidF);
      setAmountPendingF(totalAmountPendingF);
      setAmountExpiredF(totalAmountExpiredF);
      setTotalPages(Math.ceil(totalcount / memoizedFilters.itensPagina));

      // Sucesso - dados carregados
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
        navigate('/signin');
        showError("Sessão expirada", {
          description: "Faça login novamente para continuar",
          duration: 4000,
        });
      } else {
        handleError(error);
        showError("Erro ao carregar transações", {
          description: error.response?.data?.message || "Tente novamente mais tarde",
          duration: 4000,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  // Memoizar os filtros para evitar re-renders desnecessários
  const memoizedFilters = useMemo(() => filters, [
    filters.descricao,
    filters.nome,
    filters.dataInicio,
    filters.dataFim,
    filters.telefone,
    filters.id,
    filters.idTransacao,
    JSON.stringify(filters.idpdvs),
    filters.status,
    filters.geral,
    filters.itensPagina
  ]);

  useEffect(() => {
    fetchTransactions();
  }, [currentPage, memoizedFilters]);

  return {
    transactions,
    loading,
    totalPages,
    idpdvs,
    amountPaid,
    amountPending,
    amountExpired,
    amountPaidF,
    amountPendingF,
    amountExpiredF,
    error,
    refetch: fetchTransactions,
    retry: () => retry(fetchTransactions)
  };
};
